/*
 * @descripttion:全局ant-design-vue组件
 * @Author: echo
 * @Date: 2022-03-23 17:12:12
 * @LastEditors: echo
 * @LastEditTime: 2022-04-12 04:59:54
 * @autograph: 任何一个傻子都能写出让电脑能懂的代码，而只有好的程序员可以写出让人能看懂的代码
 */
import { createApp } from 'vue'
import { Button, Menu, Dropdown } from 'ant-design-vue'
export default (app: ReturnType<typeof createApp>) => {
  const components = [Button, Menu, Dropdown]
  components.map(item => app.use(item))
}
